<template>
  <b-modal ref="modal" :title="this.$t('edit-place-name')" size="md">
    <template v-if="loading">
      <div class="d-flex justify-content-center align-items-center">
        <b-spinner style="width: 5rem; height: 5rem;" />
      </div>
    </template>
    <template v-else>
      <template v-if="done">
        <div class="d-flex justify-content-center align-items-center">
          <p class="h2">{{ $t('done') | capitalize }}</p>
        </div>
      </template>
      <template v-else>
        <p v-if="isInstaller">
          <strong>{{ $t('installer-name') }}:</strong> {{ place.name }}
        </p>
        <b-form-input
          id="edit-place-name"
          type="text"
          v-model="placeUserName"
          required
          :state="placeNameIsValid"
        />
        <b-form-invalid-feedback id="edit-place-name">
          {{ $t('enter-at-least-x-letters', { count: 3 }) }}
        </b-form-invalid-feedback>
        <div class="d-flex justify-content-center">
          <b-button
            type="submit"
            variant="primary"
            size="lg"
            class="mt-3"
            :disabled="placeNameIsValid === false"
            @click="updatePlaceName">
            {{ $t('save') | capitalize }}
          </b-button>
        </div>
      </template>
    </template>

    <template v-slot:modal-footer="{ cancel }">
      <b-button @click="hide" variant="secondary">
        {{ $t('close') | capitalize }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters, mapState } from 'vuex';
import config from '@/config';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'PlaceNameEditModal',
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      placeUserName: '',
      loading: false,
      done: false,
    };
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    ...mapGetters([
      'getPlaceById',
    ]),
    ...mapGetters({
      isInstaller: 'user/isUserInstaller',
    }),
    place() {
      return this.getPlaceById(this.$route.params.placeId);
    },
    placeNameIsValid() {
      return this.placeUserName.replace(/\s/g, '').length >= 3 ? null : false;
    },
  },
  methods: {
    ...mapActions([
      'updatePlaces',
    ]),
    async updatePlaceName() {
      this.loading = true;
      const url = this.$backendUrl(
        config.ICOOL.API.PLACE_PATH(this.currentSnapshot.id, this.place.id),
      );
      try {
        const response = await axios.patch(url, { user_name: this.placeUserName });
        this.updatePlaces({ places: [response.data] });
        this.showToast(this.$t('edit-place-name'), this.$t('saved'), 'success');
      } catch (err) {
        this.$log.error(err);
        this.showToast(this.$t('edit-place-name'), this.$t('error'), 'danger');
      }
      this.done = true;
      this.loading = false;
    },
    show() {
      this.done = false;
      this.loading = false;
      this.placeUserName = this.place.user_name || this.place.name;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style scoped>

</style>
